import styled from 'styled-components';

export const Container = styled.div`
  max-width: 760px;
  padding: 8px 24px 16px;
`;

// `&&` vence o estilo global de h2/p do modal, que injeta padding e zera a margem.
export const Title = styled.h2`
  && {
    padding: 16px 0 0;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #4f4f4f;
  }
`;

export const Intro = styled.p`
  && {
    padding: 0;
    margin: 6px 0 16px;
    font-size: 13px;
    color: #828282;
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeadRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 150px 150px;
  gap: 12px;
  border-bottom: 1px solid #ebebf0;
  padding-bottom: 8px;

  > span {
    color: #828282;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 150px 150px;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid #f4f4f8;
  font-size: 13px;
  color: #4f4f4f;
  padding: 10px 0;
`;

interface RuleProps {
  empty: boolean;
}

export const Rule = styled.span<RuleProps>`
  background: ${({ empty }) => (empty ? 'transparent' : '#f4f4f8')};
  border: 1px solid ${({ empty }) => (empty ? 'transparent' : '#e4e4ee')};
  border-radius: 6px;
  color: ${({ empty }) => (empty ? '#b0b0b0' : '#4f4f4f')};
  font-size: 12px;
  padding: 4px 8px;
`;
